import React from 'react'
function Card({ img, headingpart1, headingpart2, pera, bgColor, className = '' }) {
    return (
        <div className={`${className} max-w-195 max-h-266 w-100 bg-firefly border-riverbed rounded-3 p-2`}>
            <div className='position-relative'>
                <img src={img} alt="Card img" className='w-100 h-auto obj-fit-cover' />
                <div
                    className="position-absolute bottom-0 start-0 w-100 rounded-2 h-60 z-3"
                    style={{
                        background: `linear-gradient(180deg, rgba(0, 123, 255, 0.00) 0%, ${bgColor} 68.28%)`
                    }}
                >
                    <div className='position-absolute bottom-0 start-0 w-100 text-center'>
                        <h4 className='teko fs-35 fw-bold text-white m-0 text-uppercase leading-80 px-1'><span className='teko fs-22 d-block leading-100'>{headingpart1}</span> {headingpart2}</h4>
                        <p className='text-white fs-12 fw-medium rubik fs-16 mb-2'>{pera}</p>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Card